/**
 * Concat socket orders according to unitPrice
 * @param {SocketOrder[]} orders
 * @return {SocketOrder[]}
 */
export const concatOrders = (orders) => {
    let temp = []
    let amount = 0;
    let price = 0;
    for (let i = 0; i < orders.length; i++){
        const curr = orders[i]
        if (i === orders.length - 1) {
            amount += curr.amount
            price = curr.price
            temp.push({
                ...curr, amount, price
            })
            break
        }
        if (curr.priceUnit === orders[i+1].priceUnit) {
            amount += curr.amount
            price += curr.price
        }else{
            if (!amount && !price) {
                temp.push(orders[i])
            }else{
                amount += curr.amount
                price += curr.price
                temp.push({
                    ...curr, amount, price
                })
                amount = 0
                price = 0
            }
        }
    }

    return temp
}